import Icon from '@mdi/react'
import { mdiSourceBranchPlus, mdiPlus } from '@mdi/js'
import { Layout } from 'antd'
import { BiltyStatusEnum } from '../../utils/Enums'
import { useNavigate } from 'react-router-dom'

const TableHeader = (props) => {
	const { segment, tabStatus, totalCount, collection, filteredCount, selectedRowKeys } = props
	const navigator = useNavigate()

	return (
		<Layout.Header className='flex flex-row justify-between items-center bg-white !h-16 !py-2 !px-8'>
			<div className='text-sm font-normal'>
				Showing{' '}
				{totalCount !== filteredCount ? (
					<span className='font-semibold'>
						{filteredCount}
						<span className='font-normal'> out of </span>
						{totalCount}
					</span>
				) : (
					<span className='font-semibold'>
						{totalCount} <span className='font-normal'>Total</span>
					</span>
				)}{' '}
				{collection === 'userManagement' ? 'Users' : collection === 'trackerManagement' ? 'Trackers' : tabStatus === 'issuance' ? 'Orders' : 'Jobs'}
			</div>
			{tabStatus === 'issuance' && (
				<button
					className='flex flex-row items-center justify-between bg-background w-fit btn-primary !px-3'
					disabled={selectedRowKeys?.length <= 1}
					onClick={(e) => {
						e.stopPropagation()
						navigator(`/biltyManagement/${segment}/${tabStatus}/orders/${selectedRowKeys?.join('+')}/${BiltyStatusEnum[tabStatus].biltyActionModal}`)
					}}
				>
					{selectedRowKeys?.length <= 1 ? (
						<Icon className='mr-2' path={mdiSourceBranchPlus} size={0.9} />
					) : (
						<div className='bg-white text-primary-800 mr-2 rounded-full p-0.5 text-xs w-5'>{selectedRowKeys?.length}</div>
					)}
					<div className='!text-sm !font-semibold'>Create Bilty</div>
				</button>
			)}
			{collection === 'trackerManagement' && (
				<button
					className='flex flex-row items-center justify-between bg-background w-fit btn-primary !px-3'
					onClick={(e) => {
						e.stopPropagation()
						navigator(`/trackerManagement/createTracker`)
					}}
				>
					<Icon className='' path={mdiPlus} size={1} />
					<p className='pl-1 w-full text-center font-[600] text-primary- text-xs'>Add New Tracker</p>
				</button>
			)}
		</Layout.Header>
	)
}

export default TableHeader
